// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.blockquote`
  padding-left: 1rem;
  border-left: 3px solid #96a3b6;
  font-size: 1.25rem;
`

type Props = {
  children?: any,
  style?: Object
}

const Blockquote = ({ children, style }: Props) => (
  <Component style={style}>{children}</Component>
)

export default Blockquote



// WEBPACK FOOTER //
// ./src/components/Blockquote/index.js